<ion-header mode="ios">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="close" (click)="closePage()">
        <ion-icon [src]="'/assets/icons/' + capacitor.scheme + '/x.svg'"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title *ngIf="type == 'login' || type == 'magic'">{{ capacitor.translateString('Login') }}</ion-title>
    <ion-title *ngIf="type == 'verify'">{{ capacitor.translateString('Verify') }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="medium">
    <form>
      
      <!-- Login -->

      <div *ngIf="type == 'login'">
        <div class="subtitle">{{ capacitor.translateString('LoginWelcome') }}</div>
        <ion-input type="email" mode="ios" class="input" [(ngModel)]="email" name="email" placeholder="{{ capacitor.translateString('LoginEmail') }}"></ion-input>
        <button ion-button type="submit" class="button" (click)="loginEmail()" [disabled]="!email || spinner">
          {{ capacitor.translateString('Login') }}
          <ion-spinner class="white" *ngIf="spinner"></ion-spinner>
        </button>
      </div>

      <!-- Magiclink -->

      <div *ngIf="type == 'magic'">
        <div class="subtitle">{{ capacitor.translateString('LoginMagic') }}</div>
        <button ion-button (click)="closePage()" class="button first">
          {{ capacitor.translateString('Close') }}
        </button>
        <button ion-button class="button outline grey" [disabled]="spinner" (click)="loginEmail()">
          {{ capacitor.translateString('LoginResend') }}
          <ion-spinner class="white" *ngIf="spinner"></ion-spinner>
        </button>
      </div>

      <!-- Verify -->

      <div *ngIf="type == 'verify'">
        <div class="subtitle">{{ capacitor.translateString('VerifyInfo') }}</div>
        <ion-input autocapitalize="on" type="text" mode="ios" class="input" [(ngModel)]="name" name="name" placeholder="{{ capacitor.translateString('LoginName') }}"></ion-input>
        <ion-input type="email" class="input" mode="ios" [(ngModel)]="email" name="email" placeholder="{{ capacitor.translateString('LoginEmail') }}"></ion-input>
        <button ion-button type="submit" class="button" (click)="verifyAccount()" [disabled]="!name || !email || spinner">
          {{ capacitor.translateString('LoginUpdate') }}
          <ion-spinner class="white" *ngIf="spinner"></ion-spinner>
        </button>
      </div>

      <!-- Social -->

      <div class="social" *ngIf="type != 'magic'">
        <button ion-button (click)="loginSocial('apple')" class="button apple" [disabled]="spinner" *ngIf="capacitor.platform != 'android'">
          <ion-icon [src]="'/assets/icons/' + capacitor.scheme + '/social-apple.svg'"></ion-icon> {{ capacitor.translateString('LoginApple') }}
          <ion-spinner class="white" *ngIf="spinner"></ion-spinner>
        </button>
        <button ion-button (click)="loginSocial('google')" class="button google" [disabled]="spinner">
          <ion-icon [src]="'/assets/icons/' + capacitor.scheme + '/social-google.svg'"></ion-icon> {{ capacitor.translateString('LoginGoogle') }}
          <ion-spinner class="white" *ngIf="spinner"></ion-spinner>
        </button>
      </div>

    </form>
  </ion-grid>
</ion-content>